import React, { useEffect, useState, useRef } from "react";
import { Column, Grid, Row } from "carbon-components-react";
import { Icon } from "../../components/simple/Icon";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { Trans } from "react-i18next";
import { history } from "../../helpers/history";
import { useCallback } from "react";
import { useApplication } from "../hooks/useApplication";
import { useTranslation } from "react-i18next";
import { LbLoader } from "../simple/LbLoader";
import Sidebar from "../simple/sidebar";

export const Header = () => {
  const { i18n } = useTranslation("");
  const navigate = useNavigate();
  const { isLoading, isError, data } = useApplication();
  const [sticky, setSticky] = useState(false);
  const [wasClicked, setWasClicked] = useState(false);
  const menuRef = useRef(null);
  const buttonRef = useRef(null);
  let { pathname } = useLocation();
  const handleRedirectToCreateApplication = useCallback(() => {
    history.push({ pathname: "/application/create" });
  }, []);

  const [showSidebar, setShowSidebar] = useState(
    pathname.startsWith(
      "/e-commerce/technical-document-pages/technical-document"
    )
  );

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        wasClicked &&
        menuRef.current &&
        !menuRef.current.contains(event.target) &&
        buttonRef.current &&
        !buttonRef.current.contains(event.target)
      ) {
        setWasClicked(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [wasClicked]);

  // useEffect(() => {
  //   document.body.style.overflowY = wasClicked ? "hidden" : "visible";
  // }, [wasClicked]);

  useEffect(() => {
    const handleScroll = () => {
      setSticky(window.scrollY > 1);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <>
      <header className={`lb-header  ${sticky && "sticky-shadow"} `}>
        <div className="container">
          <Grid>
            <Row>
              <Column lg={12}>
                <div className="lb-header-top">
                  <button
                    className="btn-mobile-nav"
                    ref={buttonRef}
                    onClick={() => {
                      setWasClicked(!wasClicked);
                    }}
                  >
                    <i
                      style={{ display: wasClicked ? "none" : "block" }}
                      className="icn icon-mobile-nav menu-outline"
                    >
                      <Icon name="menu-outline" viewBox="0 0 48 48" />
                    </i>
                    <i
                      style={{
                        display: wasClicked ? "block" : "none",
                        position: "fixed",
                        top: "36px",
                      }}
                      className="icn icon-mobile-nav close-outline"
                    >
                      <Icon name="close-outline" viewBox="0 0 48 48" />
                    </i>
                  </button>
                  <div className="lb-header-top__logo">
                    <Link to="/">
                      {i18n.language === "ka" ? (
                        <img src="/images/logo.svg?v=2" alt="Liberty Bank logo" />
                      ) : (
                        <img
                          src="/images/logo-eng.svg"
                          alt="Liberty Bank logo"
                        />
                      )}
                    </Link>
                  </div>
                  <div
                    className={`shadow ${wasClicked ? "visible" : "hidden"}`}
                  >
                    <div className={`lb-main-menu `} ref={menuRef}>
                      {showSidebar ? (
                        <div className="mobile-menu">
                          <div
                            className="back-menu"
                            onClick={() => {
                              setShowSidebar(false);
                              navigate("/e-commerce");
                            }}
                          >
                            <svg
                              width="24px"
                              height="24px"
                              viewBox="0 0 24 24"
                              version="1.1"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <g
                                id="Actions-/-Navigation-/-chevron--left"
                                stroke="none"
                                stroke-width="1"
                                fill="none"
                                fill-rule="evenodd"
                              >
                                <rect
                                  fill="#FFFFFF"
                                  opacity="0"
                                  x="0"
                                  y="0"
                                  width="24"
                                  height="24"
                                ></rect>
                                <polygon
                                  id="Fill"
                                  fill="#151519"
                                  points="6.5 12 14 4.5 15.05 5.55 8.6 12 15.05 18.45 14 19.5"
                                ></polygon>
                              </g>
                            </svg>
                            <Trans i18nKey="Menu.BackMainMenu" />
                          </div>

                          <Sidebar />
                        </div>
                      ) : (
                        <ul className="mobile-main-menu body-short-03">
                          {data && data.includes("POS") ? (
                            <li>
                              <Link to="/pos">
                                <Trans i18nKey="Menu.Pos" />
                              </Link>
                            </li>
                          ) : null}

                          {data && data.includes("ECOMERCE") ? (
                            <li>
                              <Link to="/e-commerce">
                                <Trans i18nKey="Menu.ECommerce" />
                              </Link>
                            </li>
                          ) : null}

                          {data && data.includes("CASHBACK") ? (
                            <li>
                              <Link to="/cashback">
                                <Trans i18nKey="Menu.Cashback" />
                              </Link>
                            </li>
                          ) : null}

                          {data && data.includes("BILLING") ? (
                            <li>
                              <Link to="/billing">
                                <Trans i18nKey="Menu.Billing" />
                              </Link>
                            </li>
                          ) : null}
                        </ul>
                      )}
                    </div>
                  </div>
                  <div className="main-nav">
                    <ul className="main-menu body-short-03">
                      {data && data.includes("POS") ? (
                        <li>
                          <Link to="/pos">
                            <Trans i18nKey="Menu.Pos" />
                          </Link>
                        </li>
                      
                      ) : null}

                      {data && data.includes("ECOMERCE") ? (
                        <li>
                          <Link to="/e-commerce">
                            <Trans i18nKey="Menu.ECommerce" />
                          </Link>
                        </li>
                      ) : null}

                      {data && data.includes("CASHBACK") ? (
                        <li>
                          <Link to="/cashback">
                            <Trans i18nKey="Menu.Cashback" />
                          </Link>
                        </li>
                      ) : null}

                      {data && data.includes("BILLING") ? (
                        <li>
                          <Link to="/billing">
                            <Trans i18nKey="Menu.Billing" />
                          </Link>
                        </li>
                      ) : null}
                    </ul>
                  </div>
                  <div className="lb-header-top__global">
                    {pathname === "/application/create" ? null : (
                      <button
                        className={`btn btn-default btn-primary ${
                          isLoading ? " text-indent btn-load" : ""
                        }`}
                        onClick={handleRedirectToCreateApplication}
                      >
                        <Trans i18nKey="Application.Create" />

                        {isLoading && (
                          <LbLoader isLoading={true} className="btn-loader" />
                        )}
                      </button>
                    )}
                  </div>
                </div>
              </Column>
            </Row>
          </Grid>
        </div>
      </header>
    </>
  );
};
